import {
  LOGIN_SUCCESS,
  AuthActionTypes,
  LOGOUT,
  LOGIN_LOADING,
  LOGIN_FAILURE,
} from './../actions/auth';

export interface AuthState {
  isLoading: boolean;
  isLogin: boolean;
  token: string;
  username: string;
  uuid: string;
  role: string;
  error: string;
}

const initialState: AuthState = {
  isLoading: false,
  isLogin: false,
  token: '',
  username: '',
  uuid: '',
  role: '',
  error: '',
};

export default (state = initialState, action: AuthActionTypes) => {
  switch (action.type) {
    case LOGIN_LOADING:
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLogin: true,
        token: '',
        username: action.payload.user.email,
        uuid: action.payload.user.uuid,
        role: action.payload.user.role,
        error: ''
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case LOGOUT:
      return {
        ...state,
        isLoading: false,
        isLogin: false,
        token: '',
        username: '',
        uuid: '',
        role: '',
      };
    default:
      return state;
  }
};
